import React, {Component} from 'react';
import moment from 'moment';
import {connect} from "react-redux";
import classnames from 'classnames';
import Loading from '../Base/Loading';
import * as AppConst from "../../constants/App";

const MONTH_I18N = [
    'calendar.january',
    'calendar.february',
    'calendar.march',
    'calendar.april',
    'calendar.may',
    'calendar.june',
    'calendar.july',
    'calendar.august',
    'calendar.september',
    'calendar.october',
    'calendar.november',
    'calendar.december'
];

const WEEK_I18N = [
    'calendar.mo',
    'calendar.tu',
    'calendar.we',
    'calendar.th',
    'calendar.fr',
    'calendar.sa',
    'calendar.su'
];

class Calendar extends Component {
    constructor(props) {
        super(props);

        let currentYear = moment().year();
        let currentMonth = moment().month();

        this.state = {
            year: currentYear,
            month: currentMonth + 1,
            cacheData: undefined,
            selected: [],
            selectedStart: {},
            selectedEnd: {}
        };

        this.refreshData = this.refreshData.bind(this);
        this.renderWeeks = this.renderWeeks.bind(this);
        this.onNextMonth = this.onNextMonth.bind(this);
        this.onPreviousMonth = this.onPreviousMonth.bind(this);
        this.onDayClick = this.onDayClick.bind(this);
        this.onDayMouseDown = this.onDayMouseDown.bind(this);
        this.onDayMouseUp = this.onDayMouseUp.bind(this);
        this.onDayMouseOver = this.onDayMouseOver.bind(this);

        this.getLoadingStyles = this.getLoadingStyles.bind(this);
        this.recalculateSelectedArea = this.recalculateSelectedArea.bind(this);
        this.ref = React.createRef();
    }

    componentDidMount() {
        let {month, year} = this.state;
        let firstDayForNewCalendar = this.getFirstDayForCalendar(month - 1, year);
        let lastDayForNewCalendar = this.getLastDayForCalendar(month - 1, year);

        this.props.onMonthChange(month, year, firstDayForNewCalendar, lastDayForNewCalendar)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let current = this.props.currentDays;
        let next = nextProps.currentDays;

        if (next === undefined) {
            this.setState({cacheData: undefined});
        }

        if (current === undefined && next !== undefined) {
            this.setState({cacheData: undefined});
        }

        if (current !== undefined && next !== undefined && JSON.stringify(current) !== JSON.stringify(next)) {
            this.setState({cacheData: undefined});
        }
    }

    refreshData() {
        let data = [];
        let dataWeek = [];

        let currentDays = this.props.currentDays;

        let year = this.state.year;
        let month = this.state.month - 1;

        let firstDayOfMonth = moment({y: year, M: month, d: 1});
        let daysInMonth = firstDayOfMonth.daysInMonth();

        let firstWeekOfMonth = firstDayOfMonth.week();


        let dayCounter = 0;
        let currentDay, currentWeek, currentWeekDay;
        let weekIterator = firstWeekOfMonth;


        // create first week if necessary
        currentDay = moment({y: year, M: month, d: 1});
        currentWeekDay = currentDay.isoWeekday();

        if (currentWeekDay !== 1) {
            for (let i = 1; i < currentWeekDay; i++) {
                currentDay = moment({y: year, M: month, d: 1}).subtract(currentWeekDay - i, 'd');

                dataWeek.push({
                    day: currentDay.date(),
                    bookingId: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].bookingId : null,
                    price: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].price : '',
                    blocked: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].blocked : false,
                    minNights: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].minNights : '',
                    date: currentDay,
                    externalCalendarName: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].externalCalendarName : null
                });

                dayCounter++;
            }
        }


        // add days from month
        for (let dayNum = 1; dayNum <= daysInMonth; dayNum++) {
            currentDay = moment({y: year, M: month, d: dayNum});
            currentWeek = currentDay.week();

            if (weekIterator === currentWeek) {

                dataWeek.push({
                    day: dayNum,
                    bookingId: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].bookingId : null,
                    price: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].price : '',
                    blocked: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].blocked : false,
                    minNights: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].minNights : '',
                    date: currentDay,
                    externalCalendarName: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].externalCalendarName : null
                });

                dayCounter++;
            } else {
                data.push(dataWeek);

                weekIterator = currentWeek;
                dataWeek = [];

                dataWeek.push({
                    day: dayNum,
                    bookingId: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].bookingId : null,
                    price: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].price : '',
                    blocked: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].blocked : false,
                    minNights: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].minNights : '',
                    date: currentDay,
                    externalCalendarName: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].externalCalendarName : null
                });

                dayCounter++;
            }
        }
        // create last week if necessary
        currentDay = moment({y: year, M: month, d: daysInMonth});
        currentWeekDay = currentDay.isoWeekday();

        if (currentWeekDay !== 7) {
            for (let i = 1; i <= 7 - currentWeekDay; i++) {
                currentDay = moment({y: year, M: month, d: daysInMonth}).add(i, 'd');

                dataWeek.push({
                    day: currentDay.date(),
                    bookingId: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].bookingId : null,
                    price: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].price : '',
                    blocked: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].blocked : false,
                    minNights: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].minNights : '',
                    date: currentDay,
                    externalCalendarName: currentDays[dayCounter] !== undefined ? currentDays[dayCounter].externalCalendarName : null
                });

                dayCounter++;
            }
        }

        // last moment
        if (dataWeek.length !== 0) {
            data.push(dataWeek);
        }

        this.setState({cacheData: data});

        return data;
    }

    getFirstDayForCalendar(month, year) {
        let firstDayOfMonth = moment({y: year, M: month, d: 1});
        let weekDay = firstDayOfMonth.isoWeekday();

        if (weekDay !== 1) {
            return firstDayOfMonth.subtract(weekDay - 1, 'd');
        } else {
            return firstDayOfMonth;
        }
    }

    getLastDayForCalendar(month, year) {
        let firstDayOfMonth = moment({y: year, M: month, d: 1});
        let daysInMonth = firstDayOfMonth.daysInMonth();
        let lastDayOfMonth = moment({y: year, M: month, d: daysInMonth});

        let currentWeekDay = lastDayOfMonth.isoWeekday();
        if (currentWeekDay !== 7) {
            return lastDayOfMonth.add(7 - currentWeekDay, 'd');
        } else {
            return lastDayOfMonth;
        }
    }

    onNextMonth(e) {
        e.preventDefault();

        let {month, year} = this.state;

        if (month === 12) {
            year = year + 1;
            month = 1;
        } else {
            month++;
        }

        this.setState({month: month, year: year}, () => {
            let firstDayForNewCalendar = this.getFirstDayForCalendar(month - 1, year);
            let lastDayForNewCalendar = this.getLastDayForCalendar(month - 1, year);

            this.props.onMonthChange(month, year, firstDayForNewCalendar, lastDayForNewCalendar);
            this.refreshData();
        });
    }

    onPreviousMonth(e) {
        e.preventDefault();

        let {month, year} = this.state;

        if (month === 1) {
            year = year - 1;
            month = 12;
        } else {
            month--;
        }

        this.setState({month: month, year: year}, () => {
            let firstDayForNewCalendar = this.getFirstDayForCalendar(month - 1, year);
            let lastDayForNewCalendar = this.getLastDayForCalendar(month - 1, year);

            this.props.onMonthChange(month, year, firstDayForNewCalendar, lastDayForNewCalendar)
            this.refreshData();
        });
    }

    onDayClick(date, price, minNights, blocked, bookingId, currentWeekNum, currentDayInWeekNum, externalCalendarName) {
        this.props.onDayClick(date, price, minNights, blocked, bookingId, currentWeekNum, currentDayInWeekNum, externalCalendarName);
    }

    onDayMouseDown(date, price, minNights, blocked, bookingId, currentWeekNum, currentDayInWeekNum) {
        let data = this.state.cacheData;

        if (data === undefined) {
            return;
        }

        let formatted = date.format(AppConst.DATE_FORMAT);

        this.setState({
            selected: [formatted],
            selectedStart: {
                date: formatted,
                weekNum: currentWeekNum,
                dayInWeekNum: currentDayInWeekNum,
            }
        });
    }

    onDayMouseUp(date, price, minNights, blocked, bookingId, currentWeekNum, currentDayInWeekNum) {
        let {cacheData, selectedStart} = this.state;

        if (cacheData === undefined || selectedStart.date === undefined) {
            return;
        }

        this.recalculateSelectedArea(date, price, minNights, blocked, bookingId, currentWeekNum, currentDayInWeekNum);
        this.setState({selectedStart: {date: undefined}});

        if (selectedStart.date === date.format(AppConst.DATE_FORMAT)) {
            this.setState({selectedStart: {date: undefined}, selected: []});
            this.props.onSelectedChange([]);
        }
    }

    onDayMouseOver(date, price, minNights, blocked, bookingId, currentWeekNum, currentDayInWeekNum) {
        let {cacheData, selectedStart} = this.state;

        if (cacheData === undefined || selectedStart.date === undefined) {
            return;
        }

        this.recalculateSelectedArea(date, price, minNights, blocked, bookingId, currentWeekNum, currentDayInWeekNum);
    }

    recalculateSelectedArea(date, price, minNights, blocked, bookingId, currentWeekNum, currentDayInWeekNum) {
        let selectedStart = this.state.selectedStart;

        let startWeek = selectedStart.weekNum > currentWeekNum ? currentWeekNum : selectedStart.weekNum;
        let endWeek = selectedStart.weekNum > currentWeekNum ? selectedStart.weekNum : currentWeekNum;

        let startWeekDay = selectedStart.dayInWeekNum > currentDayInWeekNum ? currentDayInWeekNum : selectedStart.dayInWeekNum;
        let endWeekDay = selectedStart.dayInWeekNum > currentDayInWeekNum ? selectedStart.dayInWeekNum : currentDayInWeekNum;


        let newSelected = [];
        for (let w = startWeek; w <= endWeek; w++) {
            for (let d = startWeekDay; d <= endWeekDay; d++) {
                newSelected.push(this.state.cacheData[w][d].date.format(AppConst.DATE_FORMAT));
            }
        }

        this.setState({selected: newSelected});
        this.props.onSelectedChange(newSelected);
    }

    getLoadingStyles() {
        let width = 0;
        let height = 0;

        if (this.ref.current !== null) {
            width = this.ref.current.offsetWidth;
            height = this.ref.current.offsetHeight;
        }


        return {
            marginLeft: 'auto',
            width: `${width}px`,
            marginRight: 'auto',
            height: `${height}px`,
            marginBottom: `-${height}px`
        };
    }

    render() {
        let i18n = this.props.i18n;

        return (
            <div className="calendar-property">
                <div className="calendar-property-header">
                    <button className="calendar-property-navigate previous" onClick={this.onPreviousMonth}>&lt;</button>
                    <div className={"calendar-property-current-month"}>
                        {i18n[MONTH_I18N[this.state.month - 1]]} {this.state.year}
                    </div>
                    <button className="calendar-property-navigate next" onClick={this.onNextMonth}>&gt;</button>

                    <div className="calendar-property-day-names">
                        <WeekTile name={i18n[WEEK_I18N[0]]}/>
                        <WeekTile name={i18n[WEEK_I18N[1]]}/>
                        <WeekTile name={i18n[WEEK_I18N[2]]}/>
                        <WeekTile name={i18n[WEEK_I18N[3]]}/>
                        <WeekTile name={i18n[WEEK_I18N[4]]}/>
                        <WeekTile name={i18n[WEEK_I18N[5]]}/>
                        <WeekTile name={i18n[WEEK_I18N[6]]}/>
                    </div>
                </div>
                <div className="calendar-property-month" ref={this.ref}>
                    {this.props.isLoading && <Loading style={this.getLoadingStyles()}/>}
                    {this.renderWeeks()}
                </div>
            </div>
        );
    }

    renderWeeks() {
        let data = this.state.cacheData;
        let selected = this.state.selected;

        if (data === undefined) {
            data = this.refreshData();
        }

        let weeks = [];
        let days = [];

        data.forEach((value, indexWeek) => {
            days = [];

            value.forEach((day, indexDay) => {
                days.push(
                    <DayTile
                        day={day.day}
                        bookingId={day.bookingId}
                        price={day.price}
                        blocked={day.blocked}
                        selected={selected.indexOf(day.date.format(AppConst.DATE_FORMAT)) != -1}
                        minNights={day.minNights}
                        date={day.date}
                        key={"day_" + day.date}
                        onDayClick={this.onDayClick}
                        onDayMouseDown={this.onDayMouseDown}
                        onDayMouseUp={this.onDayMouseUp}
                        onDayMouseOver={this.onDayMouseOver}
                        currentWeekNum={indexWeek}
                        currentDayInWeekNum={indexDay}
                        currencyMark={this.props.currencyMark}
                        externalCalendarName={day.externalCalendarName}
                    />
                )
            });

            weeks.push(
                <Week
                    days={days}
                    key={"week_" + weeks.length}
                />
            );
        });

        return weeks;
    }
}


const mapStateToProps = state => ({
    i18n: state.languages.i18n
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);

const WeekTile = ({name}) => {
    return <div className="calendar-property-day-name">
        {name}
    </div>
};

const Week = ({days}) => {
    return (
        <div className="calendar-property-week">
            {days}
        </div>
    );
};

const DayTile = ({blocked, day, price, minNights, date, onDayClick, bookingId, onDayMouseDown, onDayMouseUp, selected, onDayMouseOver, currentWeekNum, currentDayInWeekNum, currencyMark, externalCalendarName}) => {
    return (
        <div className={classnames("calendar-property-day", {
            'blocked': blocked,
            'selected': selected,
            'today': date.isSame(moment(), 'day'),
            'previous': date.isBefore(moment(), 'day'),
        })}
             onClick={() => {
                 onDayClick(date, price, minNights, blocked, bookingId, currentWeekNum, currentDayInWeekNum, externalCalendarName);
             }}
             onMouseDown={() => {
                 onDayMouseDown(date, price, minNights, blocked, bookingId, currentWeekNum, currentDayInWeekNum);
             }}
             onMouseUp={() => {
                 onDayMouseUp(date, price, minNights, blocked, bookingId, currentWeekNum, currentDayInWeekNum);
             }}
             onMouseOver={() => {
                 onDayMouseOver(date, price, minNights, blocked, bookingId, currentWeekNum, currentDayInWeekNum);
             }}

        >
            <span className="calendar-property-day-day">{day}</span>
            <br/>
            {bookingId !== null && <span className="calendar-property-day-booking-id">#{bookingId}</span>}
            {externalCalendarName !== null && bookingId == null && <span className="calendar-property-day-booking-id">#{externalCalendarName}</span>}
            <span className="calendar-property-day-price">
                {currencyMark}{price}
                </span>

            <span className="calendar-property-day-min-nights">
                   {minNights}
                </span>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/CreatingProperty/Calendar.js